class CartDrawer extends HTMLElement {
  constructor() {
    super();

    // Store bound event handlers as properties for proper removal
    this.boundCloseHandler = this.close.bind(this);
    this.boundStopPropagationHandler = (e) => e.stopPropagation();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );

    // Set up overlay click handlers for both shadow and cart overlay
    const overlay = this.querySelector("#CartDrawer-Overlay");
    const shadow = document.getElementById("shadow-bg-minicart");

    if (overlay) {
      overlay.addEventListener("click", this.boundCloseHandler);
    }

    if (shadow) {
      shadow.addEventListener("click", this.boundCloseHandler);
    }

    // Prevent clicks inside the drawer from closing it
    const drawerInner = this.querySelector(".drawer__inner");
    if (drawerInner) {
      drawerInner.addEventListener("click", this.boundStopPropagationHandler);
    }

    this.setHeaderCartIconAccessibility();
    const cartButton = document.querySelector("#cart-button");
    if (cartButton) {
      cartButton.addEventListener("click", (e) => {
        e.preventDefault();
        this.open(null);
      });
    }
  }

  // enableDocumentScroll() {
  //     document.body.style.overflow = 'visible'
  // }

  // disableDocumentScroll() {
  //     document.body.style.overflow = 'hidden'
  // }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    // Set up shadow background and scroll lock
    const shadow = document.getElementById("shadow-bg-minicart");
    if (shadow) {
      shadow.classList.add("is-visible");
    }

    // Disable document scroll
    document.body.style.overflow = "hidden";

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    // scrollLock.disablePageScroll()
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);

    // Clean up shadow background and scroll lock
    const shadow = document.getElementById("shadow-bg-minicart");
    if (shadow) {
      shadow.classList.remove("is-visible");
    }

    // Re-enable document scroll
    document.body.style.overflow = "auto";
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    const mobileButton = document.querySelector(".cart-count-bubble.mobile");
    const cartSpan = document.querySelector(".cart-span-counter");
    if (document.querySelector("#cart-icon-bubble .cart-count-bubble")) {
      const globalCartCounter = document.querySelector(
        "#cart-icon-bubble .cart-count-bubble"
      ).innerHTML;

      if (mobileButton) {
        mobileButton.innerHTML = globalCartCounter;
      }

      if (cartSpan) {
        cartSpan.innerHTML = globalCartCounter;
      }
    }

    // Re-attach event listeners after content update
    this.reattachEventListeners();

    setTimeout(() => {
      this.open();
    });

    // Note: Event listeners are already set up in the constructor
    // No need to duplicate them here
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  reattachEventListeners() {
    // Re-attach overlay click handlers
    const overlay = this.querySelector("#CartDrawer-Overlay");
    const shadow = document.getElementById("shadow-bg-minicart");

    if (overlay) {
      // Remove existing listener to prevent duplicates
      overlay.removeEventListener("click", this.boundCloseHandler);
      overlay.addEventListener("click", this.boundCloseHandler);
    }

    if (shadow) {
      // Remove existing listener to prevent duplicates
      shadow.removeEventListener("click", this.boundCloseHandler);
      shadow.addEventListener("click", this.boundCloseHandler);
    }

    // Re-attach drawer inner click handler to prevent propagation
    const drawerInner = this.querySelector(".drawer__inner");
    if (drawerInner) {
      // Remove existing listener to prevent duplicates
      drawerInner.removeEventListener(
        "click",
        this.boundStopPropagationHandler
      );
      drawerInner.addEventListener("click", this.boundStopPropagationHandler);
    }
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
